import React from 'react';
import Styled from './styled';

export type BadgeProps = {
    /** Badge title/text */
    title: string;
    /** Type of Badge (defaults to solid) */
    type?: 'solid' | 'outline' | 'faded';
    /** Color of Badge (defaults to primary) */
    color?: 'primary' | 'positive' | 'secondary' | 'negative' | 'neutral';
    /** Optional, badge disabled state */
    disabled?: boolean;
};

/**
 * Badge component currently integrated within Header and Bubble (optional)
 * 
 * @param {BadgeProps} props - The properties to configure the Badge component.
 * @returns {JSX.Element | null} The rendered Badge component
 */
export const Badge: React.FC<BadgeProps> = ({
    title,
    type = 'solid',
    color = 'primary',
    disabled,
}) => {

    return (
        <Styled.Badge type={type} color={color} disabled={disabled}>
            {title}
        </Styled.Badge>
    );
};
